import Community from "@/components/sections/Community";
import Reviews from "@/components/sections/Reviews";
import Diplomas from "@/components/sections/Diplomas";
import Downloads from "@/components/sections/Downloads";
import ContactForm from "@/components/sections/ContactForm";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import SectionStyles from "@/components/sections/SectionStyles";
import { useSite } from "@/contexts/SiteContext";

// Wrapper standalone care emite `data-section-key` (+ SectionStyles) în jurul unei
// secțiuni CMS montate pe pagina ei proprie. Fără acest strămoș, editorul vizual
// tratează `data-field`-urile componentei ca inerte (vezi PreviewMode: inline-edit
// necesită un strămoș [data-section-key]) → „nu pot da click să editez".
function PageWithBreadcrumb({ label, children, testId, sectionKey }) {
  const { sections } = useSite();
  const s = sectionKey ? sections.find((x) => x.key === sectionKey) : null;
  return (
    <div data-testid={testId} data-section-key={sectionKey} data-section-title={s?.title || label}>
      {s?.content && <SectionStyles scopeKey={sectionKey} content={s.content} />}
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-8 lg:pt-10">
        <Breadcrumbs items={[{ label }]} />
      </div>
      {children}
    </div>
  );
}

export function CommunityPage() { return <PageWithBreadcrumb label="Comunitate" testId="community-page" sectionKey="community"><Community /></PageWithBreadcrumb>; }
export function ReviewsPage() { return <PageWithBreadcrumb label="Testimoniale" testId="reviews-page" sectionKey="reviews"><Reviews /></PageWithBreadcrumb>; }
export function DiplomasPage() { return <PageWithBreadcrumb label="Diplome" testId="diplomas-page" sectionKey="diplomas"><Diplomas /></PageWithBreadcrumb>; }
export function DownloadsPage() { return <PageWithBreadcrumb label="Descărcări" testId="downloads-page" sectionKey="downloads"><Downloads /></PageWithBreadcrumb>; }
export function ContactPage() { return <PageWithBreadcrumb label="Contact" testId="contact-page" sectionKey="contact"><ContactForm embedded={true} /></PageWithBreadcrumb>; }
